import shortTemplate from './short.html'
import mediumTemplate from './medium.html'
import shortCompanyTemplate from './short-company_size.html'
import shortCommentsTemplate from './short-comments.html'
import short2colTemplate from './short-2-col.html'
import medium2colTemplate from './medium-2-col.html'
import preferenceCenter from './preference-center.html'
import optOut from './opt-out.html'
import educationReferral from './education-referral.html'
import long from './long.html'
import emailOnly from './email-only.html'
import shortPPIPhoneComments from './short-ppi-phone-comments.html'
import mediumComments from './medium-comments.html';

export const templates = {
    "short": shortTemplate,
    "medium": mediumTemplate,
    "short-2-col" : short2colTemplate,
    "medium-2-col" : medium2colTemplate,
    "preference-center" : preferenceCenter,
    "opt-out" : optOut,
    "short-company_size": shortCompanyTemplate,
    "short-comments": shortCommentsTemplate,
    "long": long,
    "email-only" : emailOnly,
    "education-referral" : educationReferral,
    "short-ppi-phone-comments" : shortPPIPhoneComments,
    "medium-comments": mediumComments
}

export const templateLabels = {
    "short": "Short",
    "short-2-col": "Short (2 column)",
    "medium": "Medium",
    "medium-2-col": "Medium (2 column)",
    "short-company_size": "Short + Company Size",
    "short-comments": "Short + Comments",
    //"heavy": "Heavy",
    "long": "Long",
    "email-only" : "Email Only",
    "short-ppi-phone-comments" : "Short + PPI + Phone + Comments",
    "medium-comments" : "Medium + Comments"
}
